import { HealthTabShell } from '@/components/health/HealthTabShell';
import { useParams } from 'react-router-dom';

export function GreaterAreaHealthTab() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return (
    <HealthTabShell
      basePath={`/greater-areas/${id}/health`}
      title="Greater area health"
      description="Quality checks scoped to attractions in this greater area. Pick a check to see what needs attention."
    />
  );
}
